export default "__VITE_ASSET__CSTRnESo__"